import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DashboardSearch from '../../../sharable/components/DashboardSearch';
import { ArticlesSearchByParams } from '../../../../../../constants';
import {
  changeArticlesSearchBy,
  changeArticlesSearchValue
} from '../../reducers/loadArticlesSlice';
import {
  selectArticlesSearchBy,
  selectArticlesSearchValue
} from '../../reducers/articlesSelectors';

const SEARCH_BY_OPTIONS = [
  { label: 'Title', value: ArticlesSearchByParams.Title },
  { label: 'URL', value: ArticlesSearchByParams.Url },
  { label: 'Conversation ID', value: ArticlesSearchByParams.ConversationId },
  { label: 'Article ID', value: ArticlesSearchByParams.ArticleId }
];

interface IArticlesSearchProps {
  className: string;
  onExpand: () => void;
  onCollapse: () => void;
}

const ArticlesSearch = ({ className, onExpand, onCollapse }: IArticlesSearchProps): JSX.Element => {
  const searchBy = useSelector(selectArticlesSearchBy);
  const searchValue = useSelector(selectArticlesSearchValue);
  const dispatch = useDispatch();

  const onSearchByChange = useCallback(
    (searchByValue: ArticlesSearchByParams) => {
      dispatch(changeArticlesSearchBy(searchByValue));
    },
    [dispatch]
  );

  const onSearch = useCallback(
    (value: string) => {
      dispatch(changeArticlesSearchValue(value));
    },
    [dispatch]
  );

  return (
    <DashboardSearch
      className={className}
      defaultSearchByValue={SEARCH_BY_OPTIONS[0].value}
      searchByOptions={SEARCH_BY_OPTIONS}
      searchByValue={searchBy}
      value={searchValue}
      onSearch={onSearch}
      onSearchByChange={onSearchByChange}
      onExpand={onExpand}
      onCollapse={onCollapse}
    />
  );
};

export default ArticlesSearch;
